import { Component, Show } from 'solid-js'
import { A } from '@solidjs/router'
import { AppSchema } from '/common/types'
import { getAssetUrl } from '../../util'
import { getModelUrl } from '../lib/model-util'

const GenerateImageCharacterPicker: Component<{
  character?: AppSchema.Character
  onPressChange: () => void
}> = (props) => {
  return (
    <>
      <Show when={props.character}>
        <div class="flex flex-row items-center justify-between rounded-md bg-[#313131] p-2">
          <div class="flex flex-row items-center">
            <div class="relative h-12 w-12 overflow-hidden rounded-md md:shrink-0 md:grow-0">
              {props.character?.avatar && (
                <img
                  class="absolute h-full w-full object-cover"
                  src={getAssetUrl(props.character?.avatar, true)}
                />
              )}
            </div>
            <A
              href={getModelUrl(props.character?.categorySlug, props.character?.slug)}
              class="ml-3 text-xl font-semibold text-white"
            >
              {props.character?.name}
            </A>
          </div>
          <button
            class="rounded-md border border-cosplay-gray-100 bg-[#171717] p-2 text-sm"
            onClick={props.onPressChange}
          >
            Change
          </button>
        </div>
      </Show>
      <Show when={!props.character}>
        <button
          class="flex flex-row items-center justify-center rounded-md border border-cosplay-gray-100 bg-[#171717] px-2 py-1"
          onClick={props.onPressChange}
        >
          <p class="text-md">Existing character</p>
          <img src="/images/generate-image-character-icon.png" class="ml-3 h-5 w-5" />
        </button>
      </Show>
    </>
  )
}

export default GenerateImageCharacterPicker
